import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/vip_ad1.jpg'
import _imports_1 from '@/assets/image/vip_ad2.jpg'
import _imports_2 from '@/assets/image/vip_ad3.jpg'
import _imports_3 from '@/assets/image/vip_ad4.jpg'


import BlockView from "@/views/share/BlockView.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'MainVIPSegView',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_carousel = _resolveComponent("a-carousel")!

  return (_openBlock(), _createBlock(BlockView, {
    style: {"padding":"0"},
    class: "ad"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_carousel, {
        autoplay: "",
        dots: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, { to: "/service/vip" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/service/vip" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              }, null, -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/service/vip" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_2,
                alt: ""
              }, null, -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/service/vip" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_3,
                alt: ""
              }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})